import { isAxiosError } from "axios";

export function getErrorMessage(e: unknown) {
  if (isAxiosError(e)) {
    if (e.response?.status === 400) {
      return e.response.data.message;
    }

    if (e.response?.status === 500) {
      return e.response.data.message;
    }
  }

  return "Unknown error occurred.";
}
